export const FIELD = {
  start_time: 'start_time',
  end_time: 'end_time',
  title: 'title',
  date: 'date',
  invite_ids: 'invite_ids',
};
